export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 flex justify-center lg:justify-end order-2 lg:order-1">
              <div className="relative w-[220px] h-[440px] md:w-[260px] md:h-[520px] rounded-3xl overflow-hidden bg-background-950 border-4 border-background-300">
                <div className="absolute top-0 left-0 right-0 h-8 bg-background-950 flex items-center justify-center">
                  <div className="w-20 h-1 rounded-full bg-background-700"></div>
                </div>
                <div className="pt-8 h-full bg-background-50 flex flex-col items-center justify-center px-4">
                  <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center mb-4">
                    <i className="ri-book-open-line text-2xl text-background-50"></i>
                  </div>
                  <div className="text-sm font-bold text-foreground-900 mb-1">布丁漫画</div>
                  <div className="text-xs text-foreground-400 mb-6">下拉式阅读专区</div>
                  <div className="w-full space-y-3">
                    <div className="w-full h-20 rounded-xl bg-background-200/70"></div>
                    <div className="w-full h-20 rounded-xl bg-background-200/70"></div>
                    <div className="w-full h-20 rounded-xl bg-background-200/70"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left order-1 lg:order-2">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                移动客户端
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                布丁漫画移动网页版已全面适配手机和平板设备，无需下载安装即可享受流畅的下拉式阅读体验。打开浏览器访问布丁漫画，随时随地免费看韩漫、国漫、日漫全集。收藏喜欢的作品，追更提醒不错过任何更新，阅读进度自动保存，多设备无缝同步。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-colors">
                  <i className="ri-android-line text-lg"></i>
                  <span>Android 版</span>
                </div>
                <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap hover:bg-foreground-800 transition-colors">
                  <i className="ri-apple-line text-lg"></i>
                  <span>iOS 版</span>
                </div>
                <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-700 text-sm font-medium cursor-pointer whitespace-nowrap border border-background-200 hover:bg-background-200 transition-colors">
                  <i className="ri-global-line text-lg"></i>
                  <span>网页版</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}